(function () {
  const initialized = new WeakSet();
  function initialize() {
    document.querySelectorAll('[data-cf-product]').forEach((root) => {
      if (initialized.has(root)) return;
      const picker = root.querySelector('[data-cf-option-selectors]');
      const input = root.querySelector('[data-cf-variant-id]');
      const button = root.querySelector('[data-cf-add-to-cart]');
      const price = root.querySelector('[data-cf-product-price]');
      const status = root.querySelector('[data-cf-variant-status]');
      const form = root.querySelector('[data-cf-product-form]');
      const stateElement = root.querySelector('[data-cf-selected-variant]');
      if (!picker || !input || !button || !price || !status || !form || !stateElement) return;
      let state;
      try { state = JSON.parse(stateElement.textContent); } catch (_) { return; }
      initialized.add(root);
      let controller;
      let requestNumber = 0;
      let ready = false;
      function showMedia(id) {
        const gallery = root.querySelector('[data-cf-product-gallery]');
        if (!gallery || !id || gallery.hasAttribute('data-cf-fixed-gallery')) return;
        if (gallery.cfSelectMedia) { gallery.cfSelectMedia(id); return; }
        const link = Array.from(gallery.querySelectorAll('[data-cf-media-id]')).find((item) => item.dataset.cfMediaId === String(id));
        if (link && gallery.firstElementChild !== link) gallery.prepend(link);
      }
      function applyState(nextState, message, updateMedia = true) {
        state = nextState;
        ready = Boolean(state.id && state.available);
        input.value = state.id || '';
        input.disabled = !ready;
        button.disabled = !ready;
        button.textContent = !state.id ? 'Unavailable' : state.available ? 'Add to Cart' : 'Sold out';
        status.textContent = message || (!state.id ? 'This combination is unavailable. Please choose another size or color.' : !state.available ? 'This option is sold out. Please choose another size or color.' : '');
        if (updateMedia) showMedia(state.mediaId);
      }
      const initialUrl = new URL(window.location.href);
      applyState(state, '', initialUrl.searchParams.has('variant') || initialUrl.searchParams.has('option_values'));
      form.addEventListener('submit', (event) => {
        if (!ready) event.preventDefault();
      });
      picker.addEventListener('change', async (event) => {
        if (!event.target.matches('[data-cf-product-option]')) return;
        const position = event.target.dataset.optionPosition;
        const values = Array.from(picker.querySelectorAll('[data-cf-product-option]')).map((select) => select.value);
        const number = ++requestNumber;
        if (controller) controller.abort();
        controller = new AbortController();
        const url = new URL(window.location.href);
        url.searchParams.delete('variant');
        url.searchParams.set('option_values', values.join(','));
        url.searchParams.set('section_id', root.dataset.sectionId);
        ready = false;
        input.disabled = button.disabled = true;
        button.textContent = 'Updating…';
        status.textContent = 'Updating your selection…';
        price.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(url.toString(), { signal: controller.signal });
          if (!response.ok) throw new Error('Selection request failed');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (number !== requestNumber) return;
          const updated = html.querySelector('[data-cf-product]');
          const nextPicker = updated && updated.querySelector('[data-cf-option-selectors]');
          const nextPrice = updated && updated.querySelector('[data-cf-product-price]');
          const nextStateElement = updated && updated.querySelector('[data-cf-selected-variant]');
          if (!nextPicker || !nextPrice || !nextStateElement) throw new Error('Incomplete selection response');
          const nextState = JSON.parse(nextStateElement.textContent);
          const hadFocus = picker.contains(document.activeElement);
          picker.innerHTML = nextPicker.innerHTML;
          price.innerHTML = nextPrice.innerHTML;
          applyState(nextState);
          if (hadFocus) {
            const selected = Array.from(picker.querySelectorAll('[data-cf-product-option]')).find((select) => select.dataset.optionPosition === position);
            if (selected) selected.focus({ preventScroll: true });
          }
          const pageUrl = new URL(window.location.href);
          pageUrl.searchParams.delete('option_values');
          if (state.id) pageUrl.searchParams.set('variant', state.id);
          else {
            pageUrl.searchParams.delete('variant');
            pageUrl.searchParams.set('option_values', values.join(','));
          }
          window.history.replaceState(window.history.state, '', pageUrl.toString());
        } catch (error) {
          if (error.name === 'AbortError' || number !== requestNumber) return;
          price.textContent = '—';
          button.textContent = 'Choose options';
          status.textContent = 'We couldn’t update this selection. Choose an option again to retry, or refresh the page.';
        } finally {
          if (number === requestNumber) price.removeAttribute('aria-busy');
        }
      });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
